import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { selectUserProfile } from '../../../common/category/store/slice'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { PopupBuyNow } from '../common/popupBuyNow'
import { PopupBuyPackage } from '../common/popupBuyPackage'
import { FilterList } from './FilterList'
import { TableComponent } from './TableComponent'
import './i18n'

export const AvailablePackage = () => {
  const userProfile = useSelector(selectUserProfile)

  const [isOpenBuyPackage, setIsOpenBuyPackage] = useState(false)
  const [isOpenBuyNow, setIsOpenBuyNow] = useState(false)

  const handleOpenBuyPackage = () => {
    setIsOpenBuyPackage(true)
  }

  return (
    <Panel
      label="userManagement.availablePackage.AVAILABLE_PACKAGE"
      isI18n
      renderRightHeader={() => (
        <Element
          style={{ color: '#2C73E8' }}
          className="cursorPointer"
          onClick={handleOpenBuyPackage}
        >
          <Translate value="userManagement.availablePackage.BUY_PACKAGE" />
        </Element>
      )}
    >
      <FilterList />
      <TableComponent />
      {isOpenBuyPackage && (
        <PopupBuyPackage
          isShow={isOpenBuyPackage}
          setIsShow={setIsOpenBuyPackage}
          setIsOpenBuyNow={setIsOpenBuyNow}
          userProfile={userProfile}
        />
      )}
      {isOpenBuyNow && (
        <PopupBuyNow
          isShow={isOpenBuyNow}
          setIsShow={setIsOpenBuyNow}
          userProfile={userProfile}
          isBuyPackage
        />
      )}
    </Panel>
  )
}
